/** Lobbying summary queries aggregate large filing tables and may exceed the default 10s API timeout. */
export const LOBBYING_API_TIMEOUT_MS = 60000;
